import { Injectable } from '@angular/core';
import {
  Resolve,
} from '@angular/router';
import { CheckCareConne } from '@app/store/setting/setting.classes';
import { Store } from '@ngxs/store';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CareconneResolverService implements Resolve<boolean> {
  constructor(private store: Store) { }
  resolve(): Observable<boolean> {
    this.store.dispatch(new CheckCareConne);
    return of(true);

  }
}
